import { ADMIN_ROUTE_PREFIXES, ROUTES, SITE_URL, isAdminPath } from "@/config/seoRoutes";

export { SITE_URL, ADMIN_ROUTE_PREFIXES };
export { PUBLIC_PAGE_LOCALIZED_SLUGS, getLocalizedSlugMap } from "@/lib/i18nRoutes";

export const PUBLIC_INDEXABLE_ROUTES = ROUTES
  .filter((route) => route.kind === "static" && route.indexable)
  .map((route) => ({
    path: route.path,
    priority: String(route.priority),
    changefreq: route.changefreq,
  }));

export function isAdminRoute(pathname = "/") {
  return isAdminPath(pathname);
}